import request from "@/utils/request"

// 获取验短信证码
export function getSmsCode(phone, type) {
    return request({
        url: `/expose/smsCode/${phone}/${type}`,
        method: 'get',
        isToken: false
    })
}

//获取绑定的手机号的验证码
export function getMineSmsCode(type) {
    return request({
        url: `/common/smsCode/mine/${type}`,
        method: 'get',
        isToken: true
    })
}

//验证绑定手机号验证码
export function verifyMineSmsCode(code, type) {
    return request({
        url: `/common/smsCode/verify/mine/${code}/${type}`,
        method: 'get',
        isToken: true
    })
}

//获取地区选择
export function getAreaSelect() {
    return request({
        url: `/expose/area/select`,
        method: 'get'
    })
}

//获取银行选择
export function getBankSelect() {
    return request({
        url: `/common/bank/select`,
        method: 'get'
    })
}